import React, { useRef } from 'react';
import { roadmap, arrow2, arrow3 } from '../Assets';

const Roadmap = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 500;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="w-full py-16 md:py-24 text-white" id="roadmap">
      <div className="w-full max-w-screen-xl mx-auto px-4 md:px-10 space-y-6">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase text-left">The Path Ahead</h2>

        {/* Scroll hint */}
        <p className="text-sm text-gray-400">Slide right <span className="inline-block">→</span></p>


        {/* Scrollable image */}
        <div ref={scrollRef} className="overflow-x-auto whitespace-nowrap scrollbar-hide mt-4 px-2 sm:px-4">
          <img src={roadmap} alt="Roadmap" className="inline-block w-[1200px] sm:w-[1600px] h-auto max-w-none" />
        </div>

        {/* Arrow controls */}
        <div className="flex justify-center mt-6 gap-6">
          <img
            src={arrow3}
            alt="left"
            onClick={() => scroll('left')}
            className="w-20 h-20 md:w-20 md:h-20 cursor-pointer"
          />
          <img
            src={arrow2}
            alt="right"
            onClick={() => scroll('right')}
            className="w-20 h-20 md:w-20 md:h-20 cursor-pointer"
          />
        </div>
      </div>
    </section>
  );
};

export default Roadmap;